import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimeRequest  {
    _originalTypeClassName = "zSHR.BO.OvertimeRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimeRequest.translate = translateService;
}
this.Id = null;
this.DateRequested = null;
this.OvertimeDate = null;
this.RequestedHours = null;
this.EmployeeNotes = null;
this.HRNotes = null;
this.Status = null;
this.Type = null;
this.HandledAt = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateRequested:any;
OvertimeDate:any;
RequestedHours:any;
EmployeeNotes:any;
HRNotes:any;
Status:any;
Type:any;
HandledAt:any;
EmployeeContract:any;
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}

static DomainOvertimeTypeToInterface(type: any): any{switch (type) {case Domain.OvertimeType.Overtime:
{
return 0 /* Interfaces.OvertimeAPI.OvertimeType.Overtime */;}
case Domain.OvertimeType.Overwork:
{
return 1 /* Interfaces.OvertimeAPI.OvertimeType.Overwork */;}
default:
{
return 0 /* Interfaces.OvertimeAPI.OvertimeType.Overtime */;}
}
return 0 /* Interfaces.OvertimeAPI.OvertimeType.Overtime */;
}
static InterfaceOvertimeTypeToDomain(type: any): any{switch (type) {case 0 /* Interfaces.OvertimeAPI.OvertimeType.Overtime */:
{
return Domain.OvertimeType.Overtime;}
case 1 /* Interfaces.OvertimeAPI.OvertimeType.Overwork */:
{
return Domain.OvertimeType.Overwork;}
default:
{
return Domain.OvertimeType.Overtime;}
}
return Domain.OvertimeType.Overtime;
}
static ToCalendarEvent($this: any): any{let event = new Domain.CalendarEvent();
event.Id = "Overtime_" + Joove.Common.safeNumber($this?.Id);
event.Title = $this?.EmployeeContract?.Employee?.Fullname + " +" + Joove.Common.safeNumber($this?.RequestedHours);
event.Start = $this?.OvertimeDate;
event.End = $this?.OvertimeDate;
let overtimeColor = "#F59E0B";
event.backgroundColor = overtimeColor;
event.borderColor = overtimeColor;
if ($this?.Status == Domain.LeaveRequestStatus.Pending) {let pendingColor = "#CACED5";event.backgroundColor = pendingColor;event.borderColor = pendingColor;}
return event;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}